let authStorageService = () => {

  const setAccessToken = accessToken => localStorage.setItem('access_token', accessToken);
  const getAccessToken = () => localStorage.getItem('access_token');
  const resetAccessToken = () => localStorage.removeItem('access_token');

  const setProfile = profile => localStorage.setItem('profile', JSON.stringify(profile));
  const getProfile = () => JSON.parse(localStorage.getItem('profile'));
  const resetProfile = () => localStorage.removeItem('profile');

  const resetAll = () => {
    resetAccessToken();
    resetProfile();
  };

  return {
    setAccessToken,
    getAccessToken,
    resetAccessToken,
    setProfile,
    getProfile,
    resetProfile,
    resetAll
  };
};

authStorageService.$inject = [];

export default authStorageService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/services/auth.storage.service.js